<!-- Section principale ouverte ci-dessous -->
<section class="page">
  <header class="page-header">
    <h2>Adresses</h2>
    <p class="subtitle">Gérez les adresses de livraison et de facturation associées à chaque client.</p>
  </header>

  @if (success) {
    <div class="success">{{ success }}</div>
  }
  @if (error) {
    <div class="error">{{ error }}</div>
  }

  
  <section class="panel">
    <h3>Liste des adresses</h3>
    @if (loadingList) {
      <div>Chargement...</div>
    }
    @if (!loadingList && adresses.length === 0) {
      <div>Aucune adresse enregistrée.</div>
    }
    @if (!loadingList && adresses.length) {
      <div style="margin-bottom:1rem;">
        <label for="clientFilter"><strong>Filtrer par client :</strong></label>
        <select id="clientFilter" [(ngModel)]="selectedClientId" style="margin-left:0.5em; min-width:180px;">
          <option value="">Tous les clients</option>
          @for (client of clients; track client.id) {
            <option [value]="client.id">{{ client.identifiant }}</option>
          }
        </select>
      </div>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th>Service</th>
              <th>Raison sociale</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Adresse</th>
              <th>Code postal</th>
              <th>Ville</th>
              <th>Pays</th>
              <th>Type</th>
              <th>Client</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (adresse of filteredAdresses; track adresse.id) {
              <tr>
                <td>{{ adresse.id }}</td>
                <td>{{ adresse.nom }}</td>
                <td>{{ adresse.prenom }}</td>
                <td>{{ adresse.service }}</td>
                <td>{{ adresse.raison_sociale }}</td>
                <td>{{ adresse.email }}</td>
                <td>{{ adresse.telephone }}</td>
                <td>{{ adresse.adresse }}</td>
                <td>{{ adresse.code_postal }}</td>
                <td>{{ adresse.ville }}</td>
                <td>{{ adresse.pays }}</td>
                <td>
                  <span [ngClass]="{
                    'badge-livraison': adresse.type_adresse === 'livraison',
                    'badge-facturation': adresse.type_adresse === 'facturation',
                    'badge-mixte': adresse.type_adresse === 'livraison et facturation'
                  }">
                    {{ adresse.type_adresse === 'livraison et facturation' ? 'Livraison et facturation' : adresse.type_adresse }}
                  </span>
                </td>
                <td>
                  {{ clients.find(c => c.id === adresse.client_id)?.identifiant || '—' }}
                </td>
                <td class="actions-cell">
                  <button type="button" (click)="selectAdresse(adresse.id)">Modifier</button>
                  <button type="button" class="danger" [disabled]="deletingId === adresse.id" (click)="deleteAdresse(adresse.id)">
                    {{ deletingId === adresse.id ? 'Suppression...' : 'Supprimer' }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  <!-- Fin section panel -->
